import { createRoute, useParams } from "@tanstack/solid-router";
// FLAGS: la vista de plan de clase (aula invertida) se gatea por feature (org activa).
import { withFeatureGate } from "@/features/flags/feature-gate";
import { appRoute } from "./route";
import { SessionPlanView } from "@/features/academy/components/session-plan-view";

function SessionPlanPage() {
  const params = useParams({ from: "/u/$u/schedule/$sessionId" });
  return <SessionPlanView sessionId={params().sessionId} />;
}

export const sessionPlanRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/schedule/$sessionId",
  component: withFeatureGate("academy.flipped_sessions", SessionPlanPage),
});
